import React from 'react';
import styles from './Style.module.css';
import Skeleton from 'react-loading-skeleton';

const Loader = () => {
  const skeletonCount = 2;
  const skeletonArray = Array.from({ length: skeletonCount }); // Create the array once

  return (
    <div>
      {skeletonArray.map((_, index) => (
        <React.Fragment key={index}>
          <div className={`${styles.serviceCard} ${styles.skeleton}`}>
            <h2 className={styles.title}>
              <Skeleton />
            </h2>
            <h2 className={styles.subTitle}>
              <Skeleton />
            </h2>
            <figure>
              <Skeleton />
            </figure>
            <div className={styles.package}>
              <div className={styles.left}>
                <h6>
                  <Skeleton />
                </h6>
                <div className={styles.packageDetail}>
                  <div className={styles.startingPrice}>
                    <Skeleton />
                  </div>
                  <div>|</div>
                  <div className={styles.duration}>
                    <Skeleton />
                  </div>
                </div>
              </div>
              <div className={styles.right}>
                <Skeleton />
              </div>
            </div>
          </div>
          {index < skeletonArray.length - 1 && <hr className="line" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Loader;
